import httpUtils from '../utils/http-utils';

const SERVICE_NAME = process.env.REACT_APP_API_ENDPOINT+"/footerLink";

const add = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/add", payload);
}

const edit = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/edit", payload);
}

const remove = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/delete", payload);
}

const search = (condition = {}, paginable = { rowPerPage: 999, currentPage: 1 }) => {
    return httpUtils.post(SERVICE_NAME + "/search", {condition, paginable});
}

// NMU-421: each footer layer (A/B/C) keeps its own arrangement, so both calls
// are scoped to one layer.
const saveDisplay = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/saveDisplay", payload);
}

const getDisplay = (layer) => {
    return httpUtils.post(SERVICE_NAME + "/getDisplay", { layer });
}

const footerLinkApi = {
    add,
    edit,
    remove,
    search,
    saveDisplay,
    getDisplay
}

export default footerLinkApi;